/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ pool: NonNullable<unknown>, extra: NonNullable<unknown> }} Usage_Status_Subline_UncappedInputs */



/**
* | output |
* | --- |
* | "{pool} from your pool + {extra} extra. No cap on extra usage." |
*
* @param {Usage_Status_Subline_UncappedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_status_subline_uncapped = /** @type {((inputs: Usage_Status_Subline_UncappedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Status_Subline_UncappedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.pool} aus Ihrem Pool + ${i?.extra} extra. Kein Limit auf Extra-Verbrauch.`)
	return /** @type {LocalizedString} */ (`${i?.pool} from your pool + ${i?.extra} extra. No cap on extra usage.`)
});